import {registerPlugin} from '@capacitor/core';
import type {KeePlayingCastPlugin} from './definitions';

const KeePlayingCast = registerPlugin<KeePlayingCastPlugin>('KeePlayingCast', {
    web: () => import('./web').then(m => new m.KeePlayingCastWeb()),
});

export * from './definitions';
export {KeePlayingCast};
